// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import userSlice from './redux/userSlice';

import userFilterSlice from './redux/userFilterSlice';
import filterSlice from './redux/filterReducer';

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';


// Persist config for the whole store
const persistConfig = {
  key: 'root', // Key for persisted state of the whole store
  storage, // Choose storage (localStorage)
  /** Persist đủ phiên đăng nhập — trước đây chỉ whitelist `user` khiến isLoggedIn luôn false sau F5. */
  whitelist: ['user', 'userId', 'isLoggedIn'],
};

// Create persisted reducer for the whole store (user and other reducers if any)
const persistedReducer = persistReducer(persistConfig, userSlice.reducer);

export const store = configureStore({
  reducer: {
    user: persistedReducer,
    filters: filterSlice.reducer,
    userFilters: userFilterSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
